import { render, staticRenderFns } from "./modalEvoluciones.vue?vue&type=template&id=c2c75a08&"
import script from "./modalEvoluciones.vue?vue&type=script&lang=js&"
export * from "./modalEvoluciones.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports